import script from "./IntelGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./IntelGrid.vue?vue&type=script&setup=true&lang=js"

import "./IntelGrid.vue?vue&type=style&index=0&id=861de7c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-861de7c4"]])

export default __exports__